import { call, put, select} from "redux-saga/effects";
import { toast } from "@appsmith/ads";
import { ReduxActionTypes, type ReduxAction } from "ce/constants/ReduxActionConstants";
import { getCurrentBaseApplicationId } from "selectors/editorSelectors";
import type { ApiResponse } from "api/ApiResponses";
import GitSyncAPI from "api/GitSyncAPI";
import { validateResponse } from "sagas/ErrorSagas";
import { createMessage, UPDATE_DEFAULT_BRANCH_SUCCESS } from "ce/constants/messages";
import { fetchBranchesInit, fetchGitProtectedBranchesInit } from "actions/gitSyncActions";

export function* updateGitDefaultBranchSaga(action: ReduxAction<{ branchName: string }>){
    const { branchName } = action.payload;
    const baseApplicationId: string = yield select(getCurrentBaseApplicationId);
    let response: ApiResponse | undefined;

    try {
        response = yield call(GitSyncAPI.updateGitDefaultBranch, baseApplicationId, branchName);
        const isValidResponse: boolean = yield validateResponse(response, false);
        if (isValidResponse){
            yield put({
                type: ReduxActionTypes.GIT_UPDATE_DEFAULT_BRANCH_SUCCESS,
                payload: branchName,
            })
            toast.show(createMessage(UPDATE_DEFAULT_BRANCH_SUCCESS, branchName), { kind: "success"})
            yield put(fetchBranchesInit({ pruneBranches: true }));
            yield put(fetchGitProtectedBranchesInit());
        } else {
             yield put({
                type: ReduxActionTypes.GIT_UPDATE_DEFAULT_BRANCH_ERROR,
                payload: {
                    error: response?.responseMeta?.error?.message,
                    show: true
                },
            })
        }
    } catch(error){
        yield put({
            type: ReduxActionTypes.GIT_UPDATE_DEFAULT_BRANCH_ERROR,
            payload: { error, show: true },
        })
    }
}

export function* generateCdApiKeySaga() {}

export function* toggleCdSaga() {}

export const gitExtendedSagas = {
    [ReduxActionTypes.GIT_UPDATE_DEFAULT_BRANCH_INIT]: updateGitDefaultBranchSaga,
};
